export default __webpack_public_path__ + "static/media/landscape3-Mask-industrial.89eac4cb.png";